/* -----------------Helpers--------------- */
import { cn } from "@/lib/utils";
import { type Size, Sizes, titleStyles } from "./styles";

export type TitleProps = {
	title?: string | null;
	className?: string;
	as?: React.ElementType;
	size?: Size;
	children?: React.ReactNode;
};

export const Title = ({
	as,
	children,
	className,
	size = Sizes.Section,
}: TitleProps) => {
	if (!children) {
		return null;
	}

	const Component = as ?? "h1";

	return (
		// @ts-ignore: TODO: fix this
		<Component
			// @ts-ignore: TODO: fix this
			className={cn(
				"mt-2 text-balance font-display font-medium text-gray-950 tracking-tight",
				titleStyles[size],
				className,
			)}
		>
			{children}
		</Component>
	);
};
